import { PropsWithChildren } from 'react'
import { cn } from '@/ui/utils/style'

interface BadgeProps extends PropsWithChildren {
  className?: string
}

export function Badge({ children, className }: BadgeProps) {
  return (
    <span
      className={cn(
        'block rounded-[6px] border border-border bg-muted px-2 py-1 font-normal text-[11px] text-muted-foreground leading-tight',
        className,
      )}
    >
      {children}
    </span>
  )
}

export function GradientBadge({
  children,
  className,
  innerClassName,
}: PropsWithChildren<{ className?: string; innerClassName?: string }>) {
  return (
    <div
      className={cn(
        'flex-shrink-0 rounded-[7px] bg-gradient-to-br from-gradient-yellow to-gradient-green p-[1px]',
        className,
      )}
    >
      <div className={cn('rounded-[7px] bg-[#0F0F11] px-2 py-[3px] text-muted-foreground text-xs', innerClassName)}>
        {children}
      </div>
    </div>
  )
}
